import { ReactNode } from 'react';

export interface ChildrenOrNullProps<T> {
    value: T | null | undefined;
    children: (value: T) => ReactNode;
}

export const ChildrenOrNull = <T,>(props: ChildrenOrNullProps<T>): ReactNode => {
    const { value, children } = props;

    if (!value || (Array.isArray(value) && !value.length)) return null;

    return children(value);
};
